module.exports = __webpack_public_path__ + "static/solution-organisation-ba104b0ab92d5171da05bc894933c040.png";